import en_US from 'antd/lib/locale/en_US';

en_US.DatePicker.lang.ok = 'OK'

export default en_US;